import React from 'react';
import './Offering.css';
import { Helmet } from 'react-helmet-async';



const Ablauf = () => {
    return (
        <>
            <Helmet>
                <title>Ablauf</title>
                <meta name="description" content='Die Erstberatung dient dem gegenseitigen Kennenlernen, der Anamnese sowie der Zielvereinbarung und dauert ca. 60 Minuten.
                            Die Folgeberatungen a 30 Minuten sind je nach Krankheitsbild individuell unterschiedlich gestaltet, die Inhalte werden gemeinsam festgelegt. Die Auswertung und Besprechung von Ernährungs- und Symptomtagebüchern bzw. Ernährungsprotokollen nach DGE sind Teil der Beratungen.' />
            </Helmet>
            <div className='Therapie'>
                <div className="BeratungWrapper">
                    <div className='entrycontent'>

                        <h2 className='header'>Ablauf einer Ernährungsberatung bzw. Ernährungstherapie</h2>

                        <p className='text'>Die Erstberatung dient dem gegenseitigen Kennenlernen, der Anamnese sowie der Zielvereinbarung und dauert ca. 60 Minuten.
                            Die Folgeberatungen a 30 Minuten sind je nach Krankheitsbild individuell unterschiedlich gestaltet, die Inhalte werden gemeinsam festgelegt.
                            Die Auswertung und Besprechung von Ernährungs- und Symptomtagebüchern bzw. Ernährungsprotokollen nach DGE sind Teil der Beratungen.
                            Zeil meiner individuellen Ernährungstherapie ist es, mit Ihnen gemeinsam einen Weg zu finden, der zielführend  und gleichzeitig für Sie in Ihrem privaten und beruflichen Umfeld auch zeitlich umsetzbar ist.
                            Die Ernährungstherapie dient nicht ausschließlich der Wissensvermittlung, vielmehr sehe ich sie als Teamwork und motivierende Begleitung in der Umsetzung und Erprobung Ihres veränderten Ernährungs-, Ess- und Bewegungsverhaltens.</p>

                    </div>

                </div >

            </div>
        </>);
}

export default Ablauf;
